'use client';

import a__default, { forwardRef } from "react";
import b from "../lib/IconBase.js";
import t from "../defs/Heart.js";
var i = Object.defineProperty, p = Object.defineProperties;
var s = Object.getOwnPropertyDescriptors;
var o = Object.getOwnPropertySymbols;
var c = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
var a = (r, e, t2) => e in r ? i(r, e, { enumerable: true, configurable: true, writable: true, value: t2 }) : r[e] = t2, m = (r, e) => {
  for (var t2 in e || (e = {}))
    c.call(e, t2) && a(r, t2, e[t2]);
  if (o)
    for (var t2 of o(e))
      n.call(e, t2) && a(r, t2, e[t2]);
  return r;
}, f = (r, e) => p(r, s(e));
const I = forwardRef((r, e) => /* @__PURE__ */ a__default.createElement(b, f(m({ ref: e }, r), { weights: t })));
I.displayName = "Heart";
export {
  I as Heart
};
